import useFetch from 'utils/hooks/useFetch'
import { ApiGetCommonByKey } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function CommonService() {
    const { showFail } = useModal()

    const { fetch: apiGetCommonByKey } = useFetch(ApiGetCommonByKey)
 
    const fetchCommon = async (commonKey) => {
        const res = await apiGetCommonByKey({
            data: {
                commonKey
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCommon
    }
}